export function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function supportsServiceWorkers(): boolean {
  return isBrowser() && "serviceWorker" in navigator;
}
